import { Container } from './BoxComment.styles';

type BoxCommentComponentProps = {
  children: React.ReactNode;
};

const BoxCommentComponent = function ({ children }: BoxCommentComponentProps): JSX.Element {
  return (
    <Container variant="outlined" data-testid="box-comment">
      {children}
    </Container>
  );
};

export default BoxCommentComponent;
